import type { GlobalQuasarIconMapFn } from 'quasar'


function customIconMapFn (iconName: string) {
  const iconPrefix = 'custom:'
  if (iconName.startsWith(iconPrefix)) {
    const name = iconName.substring(iconPrefix.length)
    return { icon: `svguse:/luigi/icons.svg#${name}` }
  }
}

const extendRvaiBaseIconMapFn = (): GlobalQuasarIconMapFn => (iconName: string) => {
  // Temporary fix for rvai-base icons, should be fixed in rvai-base
  const iconPrefix = 'rvai-base:'
  if (iconName.startsWith(iconPrefix)) {
    const name = iconName.substring(iconPrefix.length)
    return { icon: `svguse:/rvai-base/icons.svg#${name}` }
  }

  const customIcon = customIconMapFn(iconName)
  if (customIcon) return customIcon
}

export const iconMapFn = extendRvaiBaseIconMapFn()
